var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary-normal",class:{
    'gantt-outbox-border': (!_vm.$store.state.viewSchem.noGanttOutBoxBorder),
  },on:{"&scroll":function($event){return _vm.scrollEvent($event)}}},_vm._l((_vm.summaryHeader),function(item,index){return _c('div',{key:index,staticClass:"summary-header"},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }